import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import api from '../../../utils/axios';
import { Button } from '../../../components/ui/button';
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from '../../../components/ui/dialog';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../../components/ui/select';
import { AtencionColumnasExport, useColumnasExport } from './AtencionColumnasExport';

// C2/C3: informe semanal en Excel (lunes a domingo, hora Argentina). Por defecto la última semana completa.
export const AtencionInformeSemanal = ({ semanas = [], catalogo = {}, onDescargado }) => {
  const [open, setOpen] = useState(false);
  const [semana, setSemana] = useState(semanas[0]?.lunes);
  const [bajando, setBajando] = useState(false);
  const columnas = useColumnasExport(catalogo);
  const elegida = semanas.find((s) => s.lunes === semana) || semanas[0];

  const descargar = async () => {
    setBajando(true);
    try {
      const r = await api.get('/kpis/atencion/informe-semanal', {
        params: { semana: elegida.lunes, ...(columnas.puede ? { columnas: JSON.stringify(columnas.sel) } : {}) },
        responseType: 'blob', timeout: 120000,
      });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Atencion_Semana_${elegida.lunes}_a_${elegida.domingo}.xlsx`;
      a.click();
      URL.revokeObjectURL(url);
      toast.success('Informe descargado');
      setOpen(false);
      onDescargado?.();
    } catch (e) {
      const msg = e.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : e.response?.data?.detail;
      toast.error(msg || 'No se pudo generar el informe');
    } finally {
      setBajando(false);
    }
  };

  return (
    <>
      <Button onClick={() => { setSemana(semanas[0]?.lunes); setOpen(true); }} data-testid="atencion-informe-btn"
        className="bg-emerald-600 text-white hover:bg-emerald-700 active:scale-95 transition-transform">
        <FileSpreadsheet className="mr-1 h-4 w-4" /> Informe semanal
      </Button>
      <Dialog open={open} onOpenChange={(o) => !bajando && setOpen(o)}>
        <DialogContent className="max-w-lg" data-testid="atencion-informe-dialog">
          <DialogHeader>
            <DialogTitle>Informe semanal de Atención</DialogTitle>
            <DialogDescription>Excel con resumen y comparación con la semana anterior, grupos, bot, motivos, tipos de email, abiertos al cierre y detalle de tickets. La descarga queda registrada.</DialogDescription>
          </DialogHeader>
          <Select value={elegida?.lunes} onValueChange={setSemana}>
            <SelectTrigger data-testid="atencion-informe-semana"><SelectValue /></SelectTrigger>
            <SelectContent>
              {semanas.map((s, i) => (
                <SelectItem key={s.lunes} value={s.lunes} data-testid={`atencion-informe-semana-${s.lunes}`}>
                  {s.label}{i === 0 ? ' · última completa' : ''}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {columnas.puede ? <AtencionColumnasExport catalogo={catalogo} estado={columnas} /> : (
            <p className="text-xs text-slate-500" data-testid="atencion-export-columnas-info">Las columnas del Excel las define un administrador.</p>
          )}
          <DialogFooter>
            <Button variant="outline" onClick={() => setOpen(false)} disabled={bajando} data-testid="atencion-informe-cancelar">Cancelar</Button>
            <Button onClick={descargar} disabled={!elegida || bajando} data-testid="atencion-informe-descargar" className="bg-emerald-600 text-white hover:bg-emerald-700">
              {bajando && <Loader2 className="mr-1 h-4 w-4 animate-spin" />} Descargar Excel
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </>
  );
};
